import { addInterest } from "@/modules/lead-page/api/lead-page.v2.api";
import { AddInterestInput, InterestProperty } from "@/modules/lead-page/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export default function useAddInterest() {
  const queryClient = useQueryClient();

  const mutation = useMutation<
    AxiosResponse<InterestProperty>,
    { response?: { data?: { message?: string } } },
    { data: AddInterestInput }
  >((data) => addInterest(data), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["interests"] });
      queryClient.invalidateQueries({ queryKey: ["properties-for-interests"] });
    },
  });

  return mutation;
}
